<template>
  <div class="go-in">
    <!-- banner -->
    <banner :type="type" content="赋能体系赋能体系赋能体系赋能体系" title="赋能体系"/>
    <!-- 导航栏 -->
    <div v-if="width >= 1200" class="nav">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="天网--心理健康智慧云平台建设" name="1">
          <div id="news" class="news">
            <div class="newTitle" style="margin:100px 0 50px 0">心理健康智慧云平台建设</div>
            <div class="oneline">
              <div v-for="(item,index) in mentalHealthList" :key="index" :class="index == 0 ? 'long' : 'short'"
                   style="cursor: pointer;"
                   @click="newClick(item)">
                <img :src="imgserver + item.picture" alt="" style="border-radius: 10px">
                <!-- <span>{{ item.mainTitle }}</span>  -->
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="地网--心理服务物理空间建设" name="2">
          <div class="services">
            <div class="bodyWidth">
              <div class="title">心理服务物理空间建设</div>
              <div class="servicesBody">
                <div v-for="(item,index) in earthList" :key="index" class="body" style="cursor: pointer;"
                     @click="underground(index)">
                  <img :src="imgserver + item.picture" alt="" style="border-radius: 10px">
                  <div
                      style="font-size:26px;font-weight:700; z-index:100;position:absolute;bottom:50px;right:50px;color:#363636">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="人网--人才培养与人才选拔" name="3">
          <div class="bodyWidth">
            <!-- 人才选拔 -->
            <div class="choose">
              <div class="title lefttitle">人才选拔</div>
              <div class="societyBottom">
                <div v-for="(item,index) in box"
                     :key="index" :class="index == itemType ? 'highlight' : 'box'"
                     @click="societyClick(index,item.code)">
                  <div v-if="index == itemType" class="lines"></div>

                 <span style="font-size: 24px"> {{ item.name }}</span>
                </div>
              </div>
              <div v-if="index == 1" class="platformImg">
                <el-carousel height="440px" indicator-position="outside" style="width:620px;">
                  <el-carousel-item v-for="(list, index) in talentsStudent.pictureList" :key="index"
                                    class="el-car-item">
                    <img :src="imgserver + list" style="border-radius: 10px"/>
                  </el-carousel-item>
                </el-carousel>
                <!-- <img  style="border-radius: 10px" :src="imgserver + talentsStudent.picture" alt=""> -->
                <div class="text">
                  <div class="textTitle">{{ talentsStudent.title }}</div>
                  <div class="line"></div>
                  <div style="white-space:pre" class="ql-container ql-snow">
                  <p v-html="talentsStudent.description"></p>
                  </div>
                </div>
              </div>
              <div v-if="index == 2" class="platformImg">
                <!-- <img style="border-radius: 10px" :src="imgserver + talentsPublic.picture" alt=""> -->
                <el-carousel height="440px" indicator-position="outside" style="width:620px;">
                  <el-carousel-item v-for="(list, index) in talentsPublic.pictureList" :key="index" class="el-car-item">
                    <img :src="imgserver + list" style="border-radius: 10px"/>
                  </el-carousel-item>
                </el-carousel>
                <div class="text">
                  <div class="textTitle">{{ talentsPublic.title }}</div>
                  <div class="line"></div>
                  <div style="white-space:pre" class="ql-container ql-snow">
                    <p  v-html="talentsPublic.description"></p>
                  </div>

                </div>
              </div>
            </div>
            <!-- 人才培养 -->
            <div class="culture">
              <div class="title lefttitle">人才培养</div>
              <div class="profileBox">
                <img :src="imgserver + talentsMaster.picture" alt="" style="border-radius: 10px">
                <div class="box">
                  <div class="on">
                    <div>{{ talentsMaster.title }}</div>
                    <div style="white-space:pre" class="ql-container ql-snow">
                    <p v-html="talentsMaster.description"></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="profileBoxs">
                <img :src="imgserver + talentsBachelor.picture" alt="" style="border-radius: 10px">
                <div class="boxs">
                  <div class="ons">
                    <div>{{ talentsBachelor.title }}</div>
                    <div style="white-space:pre" class="ql-container ql-snow">
                    <p v-html="talentsBachelor.description"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 人才培训 -->
            <div class="train">
              <div class="title lefttitle">人才培训</div>
              <div class="box">
                <div class="small">
                  <div class="left">
                    <div >
                      <p style="white-space:pre" class="ql-editor ql-container ql-snow" v-html="familyEducation.description"></p>
                    </div>
                  </div>
                  <img :src="imgserver + familyEducation.picture" alt="" style="width: 355px;border-radius: 10px">
                </div>
                <div class="small">
                  <div class="left">
                    <div>
                      <p style="white-space:pre" class="ql-editor ql-container ql-snow" v-html="eapAid.description"></p>
                    </div>
                  </div>
                  <img :src="imgserver + eapAid.picture" alt="" style="width: 355px;border-radius: 10px">
                </div>
                <div class="small">
                  <div class="left">
<!--                    <div class="traintitle">{{ psychologicalCounseling.description }}</div>-->
                    <div>
                      <p style="white-space:pre" class="ql-editor ql-container ql-snow" v-html="psychologicalCounseling.description"></p>
                    </div>
                  </div>
                  <img :src="imgserver + psychologicalCounseling.picture" alt=""
                       style="width: 355px;border-radius: 10px">
                </div>
                <div class="small">
                  <div class="left">
<!--                    <div class="traintitle">{{ psychologicalGuidance.description }}</div>-->
                    <div>
                      <p style="white-space:pre" class="ql-editor ql-container ql-snow" v-html="psychologicalGuidance.description   "></p>
                    </div>
                  </div>
                  <img :src="imgserver + psychologicalGuidance.picture" alt="" style="width: 355px;border-radius: 10px">
                </div>
              </div>
            </div>
            <!-- 队伍建设 -->
            <div class="ranks">
              <div class="title lefttitle">人才资源</div>
              <div class="top">
                <el-carousel :interval="5000" height="480px">
                  <el-carousel-item v-for="item in ranks" :key="item"
                                    style="background: linear-gradient(270deg, rgba(18, 149, 136, 0.52) 5%, rgba(0, 0, 0, 0) 100%)">
                    <div class="carImgP">
                      <img :src="imgserver + item.picture" alt="" style="border-radius: 10px">
                      <div class="pContent">
                        <div style="font-size:24px;font-weight:600;">{{ item.title }}</div>
                        <p style="white-space:pre" class="ql-editor ql-container ql-snow" v-html="item.description "></p>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="和网--心理健康专业服务" name="4">
          <!-- 心理科普 -->
          <div class="popularScience">
            <!-- :style="index % 2 != 0 ? 'background: #F4FAFA;' : 'background: #fff;'" -->
            <!-- 心理科普 -->
            <div style="background-color:#fff">
              <div class="title">{{ disseminationScience.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;text-align: center !important;" class="ql-editor ql-container ql-snow" v-html="disseminationScience.description"></p>
              </div>
              <div class="bodyFour">
                <!-- <img  style="border-radius: 10px" v-for="(item,index) in disseminationScience.pictureList" :key="index" :src="imgserver + item"
                     alt=""> -->

                <el-carousel height="350px" indicator-position="outside" style="width:1440px">
                  <el-carousel-item v-for="(list, index) in disPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!-- 心理调研 -->
            <div style="background-color:#F4FAFA">
              <div class="title">{{ research.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;text-align: center !important;" class="ql-editor ql-container ql-snow" v-html=" research.description"></p>
              </div>
              <div class="bodyFour">
                <!-- <img style="border-radius: 10px" v-for="(item,index) in research.pictureList" :key="index" :src="imgserver + item" alt=""> -->
                <el-carousel height="350px" indicator-position="outside" style="width:1440px">
                  <el-carousel-item v-for="(list, index) in resPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!-- 心理测评 -->
            <div style="background-color:#fff">
              <div class="title">{{ appraisal.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;text-align: center !important;" class="ql-editor ql-container ql-snow" v-html="appraisal.description"></p>
              </div>
              <div class="bodyFour">
                <el-carousel height="350px" indicator-position="outside" style="width:1440px">
                  <el-carousel-item v-for="(list, index) in appPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <!-- <img style="border-radius: 10px" v-for="(item,index) in appraisal.pictureList" :key="index" :src="imgserver + item" alt=""> -->
              </div>
            </div>
            <!-- 心理训练 -->
            <div style="background-color:#F4FAFA">
              <div class="title">{{ drill.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;text-align: center !important;" class="ql-editor ql-container ql-snow" v-html="drill.description"></p>
              </div>
              <div class="bodyFour">
                <!-- <img style="border-radius: 10px" v-for="(item,index) in drill.pictureList" :key="index" :src="imgserver + item" alt=""> -->
                <el-carousel height="350px" indicator-position="outside" style="width:1440px">
                  <el-carousel-item v-for="(list, index) in driPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!-- 主题活动 -->
            <div style="background-color:#fff">
              <div class="title">{{ activity.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;text-align: center !important;" class="ql-editor ql-container ql-snow" v-html="activity.description"></p>
              </div>
              <div class="bodyFour">
                <el-carousel height="350px" indicator-position="outside" style="width:1440px">
                  <el-carousel-item v-for="(list, index) in actPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <!-- <img style="border-radius: 10px" v-for="(item,index) in activity.pictureList" :key="index" :src="imgserver + item" alt=""> -->
              </div>
            </div>
            <!-- 心理资讯 -->
            <div style="background-color:#F4FAFA">
              <div class="title">{{ consult.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;text-align: center !important;" class="ql-editor ql-container ql-snow" v-html="consult.description"></p>
              </div>
              <div class="bodyFour">
                <el-carousel height="350px" indicator-position="outside" style="width:1440px">
                  <el-carousel-item v-for="(list, index) in conPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <!-- <img style="border-radius: 10px" v-for="(item,index) in consult.pictureList" :key="index" :src="imgserver + item" alt=""> -->
              </div>
            </div>
          </div>


          <div class="benefit">
            <div style="width: 1440px;margin: 0 auto;display: flex">
              <div class="benefitleft">
                <div style="font-size: 24px;font-weight: 500;color:#333;">{{ active == 1 ? '心理危机干预' : '心理治疗转介' }}</div>
                <div class="line"></div>
                <div v-if="active == 1" style="display:flex;align-items:center;">
                  <div class="row"></div>
                  <p class="ql-editor ql-container ql-snow" style="white-space:pre;"
                     v-html="crisis.description"></p>
                </div>
                <div v-if="active == 2" style="display:flex;align-items:center;">
                  <div class="row"></div>
                  <p class="ql-editor ql-container ql-snow" style="white-space:pre;"
                     v-html="cure.description"></p>
                </div>
              </div>
              <div class="imgbox">
                <img v-if="active == 1" :src="imgserver + crisis.pictureList[0]" alt="" style="border-radius: 10px">
                <img v-if="active == 2" :src="imgserver + cure.pictureList[0]" alt="" style="border-radius: 10px">
                <div class="imgtab">
                  <div :class="active == 1 ? 'bottoms': 'bottom'" @click="clickHandler('1')">心理危机干预</div>
                  <div :class="active == 2 ? 'bottoms': 'bottom'" @click="clickHandler('2')">心理治疗转介</div>
                </div>
                <!-- <img class="toparrow" src="../assets/img/up.png" alt="">
                <img class="bottomarrow" src="../assets/img/down.png" alt=""> -->
              </div>
            </div>
          </div>


<!--          <div class="societyBottom">-->
<!--            <div v-for="(item,indexs) in boxTabs"-->
<!--                 :key="indexs" :class="indexs == itemTypes ? 'highlight' : 'box'"-->
<!--                 @click="societyClicks(indexs,item.code)">-->
<!--              <div v-if="indexs == itemTypes" class="lines"></div>-->
<!--              {{ item.name }}-->
<!--            </div>-->
<!--          </div>-->


<!--          <div v-if="itemTypes===0" class="popularScience" style="background: #fff;height:547px">-->
<!--            <div class="body">-->
<!--              &lt;!&ndash; <img src="../assets/img/popularScience.png" alt=""> &ndash;&gt;-->
<!--              <div class="bodycontent" style="margin-bottom: 30px">-->
<!--                <div class="bodyTitle" style="text-align: left;font-weight: 800;margin-right: 20px">{{-->
<!--                    crisis.title-->
<!--                  }}-->
<!--                </div>-->
<!--                &lt;!&ndash; <div class="line" style=""></div> &ndash;&gt;-->
<!--&lt;!&ndash;                <p>{{ crisis.description }}</p>&ndash;&gt;-->
<!--                <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="crisis.description "></p>-->
<!--              </div>-->
<!--              <img :src="imgserver + crisis.pictureList[0]" alt="" style="width:400px;height:400px;border-radius: 10px">-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else class="popularScience" style="background: #F4FAFA;height:547px">-->
<!--            &lt;!&ndash;            <div class="title">{{ cure.title }}</div>&ndash;&gt;-->
<!--            &lt;!&ndash;             <div class="twoTitle">{{ cure.title }}</div> &ndash;&gt;-->
<!--            <div class="body">-->
<!--              <img :src="imgserver + cure.pictureList[0]" alt="" style="width:400px;height:400px;border-radius: 10px">-->
<!--              <div class="bodycontent" style="margin-bottom: 30px;text-align:right">-->
<!--                <div class="bodyTitle" style="font-weight: 800;margin-left: 20px">{{ cure.title }}-->
<!--                  &lt;!&ndash;                <div class="line"></div>&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash; <div style="text-align:right">-->
<!--                     <div class="line" style=""></div>-->
<!--                </div> &ndash;&gt;-->
<!--                <p style="white-space:pre;text-align: right" class="ql-editor ql-container ql-snow" v-html="cure.description  "></p>-->
<!--              </div>-->
<!--              &lt;!&ndash; <img src="../assets/img/popularScience.png" alt=""> &ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="width <= 768" class="nav">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="天网--心理健康智慧云平台建设" name="1">
          <div id="news" class="news">
            <div class="newTitle" style="margin:100px 0 50px 0">天网--心理健康智慧云平台建设</div>
            <div class="oneline">
              <div v-for="(item,index) in mentalHealthList" :key="index" style="width: 88%;margin: 0 auto"
                   @click="newClick(item)">
                <img :src="imgserver + item.picture" alt="" style="border-radius: 10px; : inherit">
                <!-- <span>{{ item.mainTitle }}</span>  -->
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="地网--心理服务物理空间建设" name="2">
          <div class="services">
            <div style="width: 100%">
              <div class="newTitle">地网--心理服务物理空间建设</div>
              <div class="servicesBody" style="width: 100%">
                <div v-for="(item,index) in earthList" :key="index" class="body" @click="underground(index)">
                  <img :src="imgserver + item.picture" alt="" style="border-radius: 10px">
                  <div style="font-size:12px;font-weight:700; z-index:100;position:absolute;top:28%;left:8%;color:#000">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="人网--人才培养与人才选拔" name="3">
          <div>
            <!-- 人才选拔 -->
            <div class="choose">
              <div class="title lefttitle">人才选拔</div>
              <div class="societyBottom">
                <div v-for="(item,index) in box"
                     :key="index" :class="index == itemType ? 'highlight' : 'box'"
                     @click="societyClick(index,item.code)">
                  <div style="font-size: 10px !important;">{{ item.name }}</div>
                </div>
              </div>
              <div v-if="index == 1" class="platformImgs">
                <div style="width: 98%; margin: 0 auto">
                  <!-- <img style="border-radius: 10px" :src="imgserver + talentsStudent.picture" alt=""> -->
                  <el-carousel height="180px" indicator-position="outside" style="width:330px;">
                    <el-carousel-item v-for="(list, index) in talentsStudent.pictureList" :key="index"
                                      class="el-car-item">
                      <img :src="imgserver + list" style="border-radius: 10px"/>
                    </el-carousel-item>
                  </el-carousel>
                </div>

                <div class="text">
                  <div class="textTitle">{{ talentsStudent.title }}</div>
                  <div class="line"></div>
                  <div style="white-space:pre" class="ql-container ql-snow">
                    <p v-html="talentsStudent.description"></p>
                  </div>
                </div>
              </div>
              <div v-if="index == 2" class="platformImgs">
                <div style="width: 98%; margin: 0 auto">
                  <el-carousel height="180px" indicator-position="outside" style="width:330px;">
                    <el-carousel-item v-for="(list, index) in talentsPublic.pictureList" :key="index"
                                      class="el-car-item">
                      <img :src="imgserver + list" style="border-radius: 10px"/>
                    </el-carousel-item>
                  </el-carousel>
                  <!-- <img style="border-radius: 10px" :src="imgserver + talentsStudent.picture" alt=""> -->
                </div>
                <div class="text">
                  <div class="textTitle">{{ talentsPublic.title }}</div>
                  <div class="line"></div>
                  <div style="white-space:pre" class="ql-container ql-snow">
                    <p  v-html="talentsPublic.description"></p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 人才培养  -->
            <div class="culture">
              <div class="title lefttitle">人才培养</div>
              <div class="employ">
                <div class="box">
                  <div class="employtitle">{{ talentsMaster.title }}</div>
                  <div style="white-space:pre;margin-top: 10px;" class="ql-container ql-snow content">
                  <p v-html="talentsMaster.description"></p>
                  </div>
                  <img :src="imgserver + talentsMaster.picture" alt="" style="border-radius: 10px">
                </div>
                <div class="box">
                  <div class="employtitle">{{ talentsBachelor.title }}</div>
                  <div style="white-space:pre;margin-top: 10px" class="ql-container ql-snow">
                  <p v-html="talentsBachelor.description"></p>
                  </div>
                  <img :src="imgserver + talentsBachelor.picture" alt="" style="border-radius: 10px">
                </div>
              </div>
            </div>
            <!-- 人才培训 -->
            <div class="train">
              <div class="title lefttitle">人才培训</div>
              <div class="box">
                <div class="small">
                  <div class="left">
                    <div >
                      <p style="white-space:pre;font-size: 10px" class="ql-editor ql-container ql-snow" v-html="familyEducation.description"></p>
                    </div>
                  </div>
                  <img :src="imgserver + familyEducation.picture" alt="" style="width: 40%;border-radius: 10px">
                </div>
                <div class="small">
                  <div class="left">
                    <div>
                      <p style="white-space:pre;font-size: 10px"" class="ql-editor ql-container ql-snow" v-html="eapAid.description"></p>
                    </div>
                  </div>
                  <img :src="imgserver + eapAid.picture" alt="" style="width: 40%;border-radius: 10px">
                </div>
                <div class="small">
                  <div class="left">
                    <div>
                      <p style="white-space:pre;font-size: 10px"" class="ql-editor ql-container ql-snow" v-html="psychologicalCounseling.description"></p>
                    </div>
                  </div>
                  <img :src="imgserver + psychologicalCounseling.picture" alt=""
                       style="width: 40%;border-radius: 10px">
                </div>
                <div class="small">
                  <div class="left">
                    <div>
                      <p style="white-space:pre;font-size: 10px"" class="ql-editor ql-container ql-snow" v-html="psychologicalGuidance.description   "></p>
                    </div>
                  </div>
                  <img :src="imgserver + psychologicalGuidance.picture" alt="" style="width: 40%;border-radius: 10px">
                </div>
              </div>
            </div>
            <!-- 队伍建设 -->
            <div class="ranks">
              <div class="title lefttitle">人才资源</div>
              <div class="top">
                <!-- <el-carousel :interval="5000" height="200px">
                  <el-carousel-item v-for="item in ranks" :key="item">

                  </el-carousel-item>
                </el-carousel> -->
                <div v-for="item in ranks" :key="item" class="carImgP">
                  <img :src="imgserver + item.picture" alt="" style="border-radius: 10px;display:block">
                  <div class="pContent">
                    <div style="font-size:14px;font-weight:600;color:#666666">{{ item.title }}</div>
                    <p style="white-space:pre;font-size: 10px" class="ql-editor ql-container ql-snow" v-html="item.description "></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="和网--心理健康专业服务" name="4">
          <!-- 心理科普 -->
          <div class="popularScience">
            <!-- :style="index % 2 != 0 ? 'background: #F4FAFA;' : 'background: #fff;'" -->
            <!-- 心理科普 -->
            <div style="background-color:#fff">
              <div class="title">{{ disseminationScience.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="disseminationScience.description"></p>
              </div>
              <div class="bodyFour">
                <!-- <img  style="border-radius: 10px" v-for="(item,index) in disseminationScience.pictureList" :key="index" :src="imgserver + item"
                     alt=""> -->

                <el-carousel height="150px" indicator-position="outside" style="">
                  <el-carousel-item v-for="(list, index) in disPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!-- 心理调研 -->
            <div style="background-color:#F4FAFA">
              <div class="title">{{ research.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;text-align: left !important;" class="ql-editor ql-container ql-snow" v-html=" research.description"></p>
              </div>
              <div class="bodyFour">
                <!-- <img style="border-radius: 10px" v-for="(item,index) in research.pictureList" :key="index" :src="imgserver + item" alt=""> -->
                <el-carousel height="150px" indicator-position="outside">
                  <el-carousel-item v-for="(list, index) in resPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!-- 心理测评 -->
            <div style="background-color:#fff">
              <div class="title">{{ appraisal.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="appraisal.description"></p>
              </div>

              <div class="bodyFour">
                <el-carousel height="150px" indicator-position="outside">
                  <el-carousel-item v-for="(list, index) in appPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <!-- <img style="border-radius: 10px" v-for="(item,index) in appraisal.pictureList" :key="index" :src="imgserver + item" alt=""> -->
              </div>
            </div>
            <!-- 心理训练 -->
            <div style="background-color:#F4FAFA">
              <div class="title">{{ drill.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="drill.description"></p>
              </div>
              <div class="bodyFour">
                <!-- <img style="border-radius: 10px" v-for="(item,index) in drill.pictureList" :key="index" :src="imgserver + item" alt=""> -->
                <el-carousel height="150px" indicator-position="outside">
                  <el-carousel-item v-for="(list, index) in driPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!-- 主题活动 -->
            <div style="background-color:#fff">
              <div class="title">{{ activity.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="activity.description"></p>
              </div>
              <div class="bodyFour">
                <el-carousel height="150px" indicator-position="outside">
                  <el-carousel-item v-for="(list, index) in actPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <!-- <img style="border-radius: 10px" v-for="(item,index) in activity.pictureList" :key="index" :src="imgserver + item" alt=""> -->
              </div>
            </div>
            <!-- 心理资讯 -->
            <div style="background-color:#F4FAFA">
              <div class="title">{{ consult.title }}</div>
              <div class="twoContent">
                <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="consult.description"></p>
              </div>

              <div class="bodyFour">
                <el-carousel height="150px" indicator-position="outside">
                  <el-carousel-item v-for="(list, index) in conPic" :key="index" class="el-car-item">
                    <div class="bottomImgs">
                      <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" class="imgBox"
                           style="border-radius: 10px"/>
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <!-- <img style="border-radius: 10px" v-for="(item,index) in consult.pictureList" :key="index" :src="imgserver + item" alt=""> -->
              </div>
            </div>
          </div>
          <div class="popularScience" style="background: #fff;">
            <div class="title">{{ crisis.title }}</div>
            <!-- <div class="twoTitle">{{ crisis.title }}</div> -->
            <div class="body">
              <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="crisis.description"></p>
              <!-- <div class="bodycontent"> -->
              <!-- <div class="bodyTitle">{{ crisis.title }}</div> -->
              <!-- <p>{{ crisis.description }}</p> -->
              <!-- </div> -->
               <img style="width:100%;height:150px;object-fit: cover" :src="imgserver + crisis.pictureList[0]" alt="">
            </div>
          </div>
          <div class="popularScience" style="background: #F4FAFA;">
            <div class="title">{{ cure.title }}</div>
            <!-- <div class="twoTitle">{{ cure.title }}</div> -->
            <div class="body">
              <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="cure.description "></p>
               <img style="width:100%;height:150px;object-fit: cover" :src="imgserver + cure.pictureList[0]" alt="">
              <!-- <div class="bodycontent">
                  <div class="bodyTitle">{{ cure.title }}</div>

              </div> -->
              <!-- <img src="../assets/img/popularScience.png" alt=""> -->
            </div>
          </div>

        </el-tab-pane>
      </el-tabs>
    </div>
    <contact></contact>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import {getearthMatOne, gethoaNet, gethumanNetwork, getskynet} from "../api/api";
import Contact from "@/components/contact.vue";

export default {
  data() {
    return {
      activeName: '1',
      indexes:1,
      width: document.body.clientWidth,
      mentalHealthList: [],
      itemType: 0, // 等级筛选选中的标识
      materialCode: '', // 分类的code值
      earthList: [],
      itemTypes:0,
      boxTabs:[
        {
          name: '心理危机干预',
          code: ""
        },
        {
          name: '心理治疗转介',
          code: ""
        },
      ],
      box: [
        {
          name: '中小学生心理健康成长测评工具',
          code: ""
        },
        {
          name: '公安干警胜任力测评工具',
          code: ""
        },
      ],
      active:1,
      talentsStudent: {},//中小学生测评
      talentsPublic: {},//胜任
      talentsMaster: {},//硕士研究生
      talentsBachelor: {},//本科
      index: 1,
      familyEducation: {},//家庭教育
      eapAid: {},//EAP援助师
      psychologicalCounseling: {},//心理咨询师
      psychologicalGuidance: {},//社会心理服务
      ranks: [],
      disseminationScience: {},//心里科普
      disPic: [],
      research: {},//心理调研
      resPic: [],
      appraisal: {},//心理测评
      appPic: [],
      drill: {},//心理训练
      driPic: [],
      activity: {},//主题活动
      actPic: [],
      consult: {},//心理资讯
      conPic: [],
      crisis: {},//心理危机干预
      cure: {},//心理危机干预
      type: 6
    };
  },
  components: {
    Contact,
    Banner,
  },
  watch: {
    width(val) {
      console.log('实时屏幕宽度：', val, this.width)
    }
  },
  mounted() {
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName
    }
    let that = this
    window.addEventListener("resize", function (e) {
      that.width = e.target.document.documentElement.clientWidth
    });
    this.onload()
  },
  methods: {
    clickHandler(i) {
      this.active = i
    },
    handleClick(tab) {
      this.activeName = tab.name
      if (this.activeName == 1) {
        this.type = 6
      } else if (this.activeName == 2) {
        this.type = 7
      } else if (this.activeName == 3) {
        this.type = 8
      } else if (this.activeName == 4) {
        this.type = 9
      }
    },
    onload() {
      getskynet().then(res => {
        this.mentalHealthList = res.data.data
      })
      getearthMatOne().then(res => {
        this.earthList = res.data.data
      })
      gethumanNetwork().then(res => {
        this.talentsStudent = res.data.data.talentsStudent
        this.talentsPublic = res.data.data.talentsPublic
        this.talentsMaster = res.data.data.talentsMaster
        this.talentsBachelor = res.data.data.talentsBachelor
        this.familyEducation = res.data.data.familyEducation
        this.eapAid = res.data.data.eapAid
        this.psychologicalCounseling = res.data.data.psychologicalCounseling
        this.psychologicalGuidance = res.data.data.psychologicalGuidance
        this.ranks = res.data.data.resource
      })
      gethoaNet().then(res => {
        this.disseminationScience = res.data.data.disseminationScience
        this.disPic = this.disseminationScience.pictureList
        this.getPic(this.disPic)
        this.research = res.data.data.research
        this.resPic = this.research.pictureList
        this.getPic2(this.resPic)
        this.appraisal = res.data.data.appraisal
        this.appPic = this.appraisal.pictureList
        this.getPic3(this.appPic)
        this.drill = res.data.data.drill
        this.driPic = this.drill.pictureList
        this.getPic4(this.driPic)
        this.activity = res.data.data.activity
        this.actPic = this.activity.pictureList

        this.getPic5(this.actPic)
        this.consult = res.data.data.consult
        this.conPic = this.consult.pictureList
        this.getPic6(this.conPic)
        this.crisis = res.data.data.crisis
        this.cure = res.data.data.cure
      })

    },
    getPic(list) {
      let newDataList = []
      let current = 0
      if (list && list.length > 0) {
        for (let i = 0; i <= list.length - 1; i++) {
          if (i % 3 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([list[i]])
            } else {
              newDataList[current].push(list[i])
            }
          } else {
            current++
            newDataList.push([list[i]])
          }
        }
      }
      this.disPic = [...newDataList]
    },
    getPic2(list) {
      let newDataList = []
      let current = 0
      if (list && list.length > 0) {
        for (let i = 0; i <= list.length - 1; i++) {
          if (i % 3 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([list[i]])
            } else {
              newDataList[current].push(list[i])
            }
          } else {
            current++
            newDataList.push([list[i]])
          }
        }
      }
      this.resPic = [...newDataList]
    },
    getPic3(list) {
      let newDataList = []
      let current = 0
      if (list && list.length > 0) {
        for (let i = 0; i <= list.length - 1; i++) {
          if (i % 3 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([list[i]])
            } else {
              newDataList[current].push(list[i])
            }
          } else {
            current++
            newDataList.push([list[i]])
          }
        }
      }
      this.appPic = [...newDataList]
    },
    getPic4(list) {
      let newDataList = []
      let current = 0
      if (list && list.length > 0) {
        for (let i = 0; i <= list.length - 1; i++) {
          if (i % 3 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([list[i]])
            } else {
              newDataList[current].push(list[i])
            }
          } else {
            current++
            newDataList.push([list[i]])
          }
        }
      }
      this.driPic = [...newDataList]
    },
    getPic5(list) {
      let newDataList = []
      let current = 0
      if (list && list.length > 0) {
        for (let i = 0; i <= list.length - 1; i++) {
          if (i % 3 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([list[i]])
            } else {
              newDataList[current].push(list[i])
            }
          } else {
            current++
            newDataList.push([list[i]])
          }
        }
      }
      this.actPic = [...newDataList]
    },
    getPic6(list) {
      let newDataList = []
      let current = 0
      if (list && list.length > 0) {
        for (let i = 0; i <= list.length - 1; i++) {
          if (i % 3 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([list[i]])
            } else {
              newDataList[current].push(list[i])
            }
          } else {
            current++
            newDataList.push([list[i]])
          }
        }
      }
      this.conPic = [...newDataList]
    },
    newClick(item) {
      console.log(item)
      this.$router.push({
        path: '/earthDetail',
        query: {
          id: item.linkUrl,
          title: item.title
        }
      })
    },
    //详情页
    underground(i) {
      if (i == 1) {
        this.$router.push({
          path: '/mentally',
        })
      } else {
        this.$router.push({
          path: '/physics',
        })
      }
    },
    societyClick(i, code) {
      this.itemType = i
      if (i == 0) {
        this.index = 1
      } else {
        this.index = 2
      }
      window.console.log(this.itemType, 'itemtype');
      this.materialCode = code
    },

    societyClicks(i, code) {
      this.itemTypes = i
      if (i == 0) {
        this.indexes = 1
      } else {
        this.indexes = 2
      }
      window.console.log(this.itemType, 'itemtype');
    },
  }
};
</script>

<style>
.societyBottom {
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  line-height: 80px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;

  .box {
    text-align: center;
    color: #888888;
    margin-right: 20px;
  }

  .highlight {
    text-align: center;
    color: #3D3D3D;
    margin-right: 20px;
    font-weight: 600;
  }
}
</style>


<style lang="scss" scoped>
@import url('../assets/font/font.css');

* {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei;
  font-size: 16px;
}

.line {
  width: 47px;
  height: 4px;
  box-sizing: border-box;
  background-color: #238B81;
  //   border-width: 0px 0px 4px 0px;
  //   border-style: solid;
  //   border-color: #238B81;
  margin: 20px 0;
}

::v-deep .el-carousel__button {
  width: 15px !important;
  height: 11px !important;
  border-radius: 35px !important;
  bottom: 0px;
}

::v-deep .el-carousel__indicators--horizontal {
  bottom: 0px;
}

.go-in {
  width: 100%;
  height: 100%;
}

.bodyWidth {
  width: 1440px;
  margin: 0 auto;
}


.lefttitle {
  text-align: left;
}

.twoTitle {
  font-size: 14px;
  font-weight: normal;
  line-height: 50px;
  text-transform: uppercase;
  letter-spacing: 0px;
  color: #888888;
  text-align: center;
}

.nav {
  width: 100%;
  box-sizing: border-box;
}

::v-deep .el-tabs--card {
  width: 100%;
  border: 0 !important;
  box-sizing: border-box;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none !important;
  background-color: #fff !important;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
}

::v-deep .el-tabs__item .is-active {
  color: #34A59A !important;
}

::v-deep .el-tabs__item:hover {
  color: #333333 !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #fff !important;
  color: #34A59A !important;
  border-bottom-color: transparent !important;
}

::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: none !important;
  box-shadow: 0px 4px 10px 0px #E9F5F9;
  display: flex;
  justify-content: space-around;
  padding: 15px 0;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

::v-deep .el-carousel__item {
  border-radius: 10px;
  //   background: linear-gradient(270deg, rgba(18, 149, 136, 0.52) 5%, rgba(0, 0, 0, 0) 100%) !important;
}

::v-deep .el-tabs__item {
  color: #666666 !important;
}

@media (min-width: 1200px) {
  //公共样式
  .title {
    font-size: 30px;
    font-weight: 700;
    letter-spacing: 0px;
    color: #333333;
    text-align: center;
    padding-top: 50px;
  }
  .twoContent {
    margin: 20px 14px 30px 14px;
  }
  .news {
    width: 1440px;
    //height: 100vh;
    margin: 0 auto;
    padding: 20px 0 30px 0;
    box-sizing: border-box;

    .newTitle {
      font-size: 30px;
      font-weight: 700;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      margin-bottom: 30px;
      text-align: center;
    }

    .oneline {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0em;
      color: #FFFFFF;

      .long {
        width: 66.5%;
        border-radius: 10px;
        // height: 440px;
        // position: relative;
        // border-radius: 10px;
        // span{
        //     position: absolute;
        //     bottom: 130px;
        //     left: 80px;
        // }
        // .text{
        //     position: absolute;
        //     left: 80px;
        //     bottom:100px;
        // }
        img {
          width: 100%;
          height: 350px;
        }
      }

      .short {
        width: 33%;
        border-radius: 10px;
        // height: 340px;

        // position: relative;
        // span{
        //     position: absolute;
        //     bottom: 130px;
        //     left: 80px;
        // }
        // .text{
        //     position: absolute;
        //     left: 80px;
        //     bottom:100px;
        // }
        img {
          width: 100%;
          height: 350px
        }
      }
    }
  }
  .benefit {
    width: 100%;
    height: 400px;
    background: #F8FBFB;
    margin-top: 80px;
    margin-bottom: 80px;
    display: flex;

    .imgbox {
      width: 40%;
      height: 400px;
      object-fit: cover;
      position: relative;
      box-sizing: border-box;

      img {
        width: 100%;
        height: 100%;
      }

      .toparrow {
        width: 24px;
        height: 24px;
        position: absolute;
        bottom: 90px;
        left: 40px;
      }

      .bottomarrow {
        width: 24px;
        height: 24px;
        position: absolute;
        bottom: 50px;
        left: 40px;
      }
    }

    .benefitleft {
      width: 65%;
      box-sizing: border-box;
      padding: 60px;
    }

    .line {
      width: 47px;
      height: 4px;
      box-sizing: border-box;
      border-width: 0px 0px 4px 0px;
      border-style: solid;
      border-color: #238B81;
      margin: 20px 0;
    }

    p {
      font-weight: normal;
      letter-spacing: 0px;
      color: #666666;
      margin-top: 10px;
    }

    // .row{
    //     display:inline-block;
    //     height:4px;
    //     width:4px;
    //     border-radius: 4px;
    //     background: #666666;
    //     margin-right:10px;
    //     margin-top: 10px;
    // }

    .imgtitle {
      position: absolute;
      top: 60px;
      left: 40px;
      font-size: 30px;
      font-weight: 500;
      line-height: 50px;
      letter-spacing: 0px;
      color: #FFFFFF;
    }

    .imgtab {
      position: absolute;
      top: 120px;
      left: 40px;
      width: 120px;
      // height: 50px;
      font-size: 20px;
      font-weight: 500;
      line-height: 50px;
      letter-spacing: 0px;
      color: #FFFFFF;

    }

    .bottom {
      font-size: 20px;
      font-weight: normal;
      cursor: pointer;
    }

    .bottoms {
      font-size: 20px;
      font-weight: 600;
      border-bottom: 2px solid #fff;
      cursor: pointer;
    }

    .span {
      font-size: 16px;
      // font-weight: 700;
      cursor: pointer;
    }
  }

  .services {
    width: 100%;
    // height: 80vh;
    padding: 24px 0;
    box-sizing: border-box;
    background: #EEF5F6;

    .newTitle {
      font-size: 18px;
      font-weight: 700;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      //margin-bottom: 30px;
      text-align: center;
    }

    .servicesBody {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      // justify-content: center;
      .body {
        width: 689.82px;
        height: 480px;
        // margin-left: 20px;
        margin-top: 30px;
        position: relative;

        img {
          width: 689.82px;
          height: 480px;
        }

        .bodyTitle {
          color: #fff;
          position: absolute;
          bottom: 30px;
          left: 30px;
        }
      }
    }
  }

  .choose {
    width: 100%;
    // height: 80vh;
    padding: 50px 0;
    box-sizing: border-box;

    .societyBottom {
      width: 100%;
      font-size: 24px;
      font-weight: 500;
      line-height: 80px;
      display: flex;
      justify-content: flex-start;
      cursor: pointer;

      .box {
        text-align: center;
        color: #888888;
        margin-right: 20px;
      }

      .highlight {
        text-align: center;
        color: #3D3D3D;
        margin-right: 20px;
        font-weight: 600;
      }
    }

    .platformImg {
      width: 100%;
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      color: white;
      background: linear-gradient(270deg, rgba(18, 149, 136, 0.52) 5%, rgba(0, 0, 0, 0) 100%);;

      img {
        width: 620px;
        height: 440px;
      }

      .text {
        padding: 50px;
        width: 50%;
        color: black;
        box-sizing: border-box;

        .textTitle {
          font-size: 24px;
          font-weight: 500;
          line-height: 35px;
        }

        .line {
          width: 100%;
          height: 1px;
          background: #D8D8D8;
          margin: 20px 0;
        }

        p {
          font-size: 16px;
          font-weight: normal;
          line-height: 26px;
          color: #666666;
        }
      }
    }
  }

  .culture {
    width: 100%;
    padding: 50px 0;
    box-sizing: border-box;

    .profileBox {
      width: 100%;
      background: linear-gradient(270deg, rgba(18, 149, 136, 0.52) 5%, rgba(0, 0, 0, 0) 100%) !important;
      // height: 35vh;
      height: 440px;

      position: relative;

      margin-top: 100px;

      img {
        width: 720px;
        height: 440px;
        position: absolute;
        top: -50px;
        left: 0;
        z-index: 100;
        border-radius: 10px;
      }

      .box {
        width: 97%;
        height: 100%;
        border-radius: 10px;
        //background: #EEF5F6;
        position: absolute;
        right: 0;

        .on {
          width: 40%;
          height: 100%;
          position: absolute;
          right: 60px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          box-sizing: border-box;
          padding-top: 20px;

          div {
            font-size: 28px;
            font-weight: 500;
            line-height: 50px;
            letter-spacing: 0em;
            color: #333333;
            margin-top: 10px;
          }

          p {
            font-size: 16px;
            font-weight: normal;
            line-height: 30px;
            letter-spacing: 0em;
            color: #666666;
            margin-top: 10px;
          }

        }
      }
    }

    .profileBoxs {
      width: 100%;
      height: 440px;
      position: relative;
      background: linear-gradient(270deg, rgba(0, 0, 0, 0) 5%, rgba(18, 149, 136, 0.52) 100%);;
      margin-top: 100px;

      img {
        width: 720px;
        height: 440px;
        position: absolute;
        top: -50px;
        right: 0;
        z-index: 100;
        border-radius: 10px;
      }

      .boxs {
        width: 97%;
        height: 100%;
        border-radius: 10px;
        //background: #EEF5F6;
        position: absolute;
        left: 0;

        .ons {
          width: 40%;
          height: 100%;
          position: absolute;
          left: 60px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          box-sizing: border-box;
          padding-top: 30px;

          div {
            font-size: 28px;
            font-weight: 500;
            line-height: 50px;
            letter-spacing: 0em;
            color: #333333;
            margin-top: 10px;
          }

          p {
            font-size: 16px;
            font-weight: normal;
            line-height: 30px;
            letter-spacing: 0em;
            color: #666666;
            margin-top: 10px;
          }

        }
      }
    }
  }

  .train {
    width: 100%;
    padding: 30px 0;
    box-sizing: border-box;
    border-radius: 10px;

    .box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex: 2;
      box-sizing: border-box;
      margin-top: 30px;
    }

    .left {
      // width: 100%;
      // height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .small {
      // width: 49.2%;
      // height: 25vh;
      width: 710px;
      background: #EEF5F6;
      border-radius: 10px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;

      .traintitle {
        color: #000000;
        font-size: 18px;
        box-sizing: border-box;
        padding: 0 30px;
        font-weight: 500;
      }

      img {
        border-radius: 10px;
        width: 355px;
        height: 237px;
      }

      // .el-button{
      //     padding: 10px 20px;
      //     border-radius: 10px;
      //     background: #34A59A;
      //     color: #fff;
      //     box-sizing: border-box;
      //     margin-left: 30px;
      //     width: 125px;
      //     height: 43px;
      // }
    }
  }

  .ranks {
    width: 1440px;
    margin: 0 auto;
    // height: 60vh;
    // padding: 50px 0 100px 0;
    // box-sizing: border-box;
    .top {
      width: 100%;
      height: 480px;
      margin: 50px 0;
      border-radius: 10px;
    }

    .ranktitle {
      color: #3D3D3D;
      font-size: 24px;
      margin-top: 10px;
    }

    .carImgP {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-around;
      // align-items: flex-start;
      color: #fff;
      box-sizing: border-box;
      padding-top: 60px;

      img {
        width: 40%;
        height: 294px;
      }

      .pContent {
        width: 40%;
        padding-top: 30px;

        p {
          margin-top: 30px;
        }
      }
    }
  }

  .popularScience {
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    //   height: 695px;
    //   padding-top: 50px;
    .body {
      width: 1440px;
      margin: 0 auto;
      height: 547px;
      display: flex;
      align-items: center;
      // align-items: flex-start;
      justify-content: space-between;

      img {
        width: 431px;
        height: 431px;
      }
    }

    // height: 80vh;
    .bodyFour {
      width: 1440px;
      margin: 0 auto;
    }

    .bottomImgs {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .imgBox {
        width: 442px;
        height: 326px;
      }
    }

    .bodycontent {
      width: 40%;
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;

      .bodyTitle {
        font-size: 24px;
        font-weight: normal;
        line-height: 50px;
        letter-spacing: 0px;
        color: #000000;
        box-sizing: border-box;
        padding-top: 50px;
      }

      p {
        font-size: 16px;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0em;
        color: #666666;
        margin: 20px 0;
      }

      .el-button {
        color: #fff;
        margin-top: 10px;
        background: linear-gradient(270deg, #3EDACB 0%, #34B4A8 100%);
        width: 100px;
        height: 40px;
      }
    }

    .bodyFour {
      width: 1440px;
      margin: 0 auto;
      padding: 0 0 50px 0;
      box-sizing: border-box;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      img {
        width: 24%;
        height: 325px;
      }
    }

    // }
  }
}

::v-deep .el-tabs--card > .el-tabs__header {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  * {
    // background-color: #efefef;
  }
  .title,
  .eTitle {
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    color: #333333;
    text-align: center;
    margin-bottom: 20px;
    padding-top: 20px;
  }
  .nav {
    width: 100%;
    // padding: 20px 0 0 0;
    //height: 50px;
    line-height: 50px !important;
    // box-shadow: 0px 4px 10px 0px #E9F5F9;
    margin-bottom: 20px;
    box-sizing: border-box;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: none !important;
    background-color: #fff !important;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    height: 30px;
    // padding: 0;
  }
  ::v-deep .el-tabs--card > .el-tabs__header {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  ::v-deep .el-carousel__button {
    width: 5px;
    height: 8px;
    border-radius: 35px;
    background: rgba(216, 216, 216, 0.55);
  }
  ::v-deep .el-tabs__nav-scroll {
    width: 100%;
    margin: 0 auto;
  }
  .news {
    width: 100%;
    margin: 0 auto;
     //height: 100vh;
    padding: 0px 0 30px 0;
    box-sizing: border-box;

    .newTitle {
      margin: 24px 0px 16px 0px !important;
      font-size: 18px;
      font-weight: 800;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      //margin-bottom: 30px;
      text-align: center;
    }

    .oneline {
      width: 100%;
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0em;
      color: #FFFFFF;

      img {
        border-radius: 10px;
        width: 100%;
        height: 180px;
      }
    }

  }
  .services {
    width: 100%;
    // height: 80vh;
    padding: 50px 0;
    box-sizing: border-box;
    background: #EEF5F6;

    .newTitle {
      margin: 24px 0px 16px 0px !important;
      font-size: 18px;
      font-weight: 800;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      //margin-bottom: 30px;
      text-align: center;
    }

    .servicesBody {
      width: 100% !important;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      // justify-content: center;
      .body {
        width: 100%;
        height: 480px;
        //margin: 30px auto;
        margin-left: 12px;
        //margin-top: 30px;
        position: relative;

        img {
          width: 170px;
          height: 170px;
        }

        .bodyTitle {
          color: #fff;
          position: absolute;
          bottom: 30px;
          left: 30px;
        }
      }
    }
  }
  .choose {
    width: 100%;
    // height: 80vh;
    padding: 50px 0;
    box-sizing: border-box;

    .societyBottom {
      width: 90%;
      font-size: 10px !important;
      margin: 0 auto;
      font-weight: 500;
      line-height: 80px;
      display: flex;
      justify-content: space-around;

      .box {
        text-align: center;
        color: #888888;
        margin-right: 20px;
        div{
          font-size: 10px !important;
        }
      }

      .highlight {
        text-align: center;
        color: #3D3D3D;
        border-top: 3px solid #238B81;
        margin-right: 20px !important;
        font-weight: 600;
        div{
          font-size: 24px !important;
        }
      }

      .line {
        margin: -4px;
      }
    }

    .platformImgs {
      width: 90%;
      margin: 30px auto;

      img {
        width: 100%;
        margin: 0 auto;
        height: 173px;
      }

      .text {
        padding-top: 50px;
        width: 100%;
        color: black;
        box-sizing: border-box;

        .textTitle {
          font-size: 16px;
          font-weight: 600;
          line-height: 14px;
          letter-spacing: 0px;
        }

        .line {
          width: 100%;
          height: 1px;
          background: #D8D8D8;
          margin: 20px 0;
        }

        p {
          font-size: 12px;
          font-weight: normal;
          line-height: 26px;
          color: #666666;
        }
      }
    }
  }
  .culture {
    width: 100%;
    padding: 1px 0;
    box-sizing: border-box;
    line-height: 20px !important;

    .employ {
      width: 90%;
      //margin-bottom: 20px;
      margin: 20px auto;
      color: #fff;


      .box {
        width: 100%;
        height: 200px;
        margin-top: 20px;
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        background-size: 100% 100%;
        position: relative;

        .el-button.is-round {
          border-color: #fff;
          color: #fff;
          margin-top: 10px;
          width: 20%;
          padding: 5px;
          font-size: 12px;
          background-color: transparent;

        }

        img {
          width: 100%;
          height: 200px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
        }

        .employtitle {
          font-size: 14px;
          font-weight: 600;
        }
        .content{
          height: 136px;overflow-y: scroll
        }

        p {
          font-size: 12px !important;
        }
      }
    }

    .profileBoxs {
      width: 100%;
      height: 440px;
      position: relative;
      margin-top: 100px;

      img {
        width: 720px;
        height: 440px;
        position: absolute;
        top: -50px;
        right: 0;
        z-index: 100;
        border-radius: 10px;
      }

      .boxs {
        width: 97%;
        height: 100%;
        border-radius: 10px;
        background: #EEF5F6;
        position: absolute;
        left: 0;

        .ons {
          width: 40%;
          height: 100%;
          position: absolute;
          left: 60px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          box-sizing: border-box;
          padding-top: 30px;

          div {
            font-size: 28px;
            font-weight: 500;
            line-height: 50px;
            letter-spacing: 0em;
            color: #333333;
            margin-top: 10px;
          }

          p {
            font-size: 16px;
            font-weight: normal;
            line-height: 30px;
            letter-spacing: 0em;
            color: #666666;
            margin-top: 10px;
          }

        }
      }
    }
  }
  .train {
    width: 100%;
    padding: 30px 0;
    box-sizing: border-box;
    border-radius: 10px;

    .box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex: 2;
      box-sizing: border-box;
      line-height: 20px !important;
      margin-top: 30px;
    }

    .left {
      // width: 100%;
      // height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .small {
      // width: 49.2%;
      // height: 25vh;
      width: 95%;
      margin: 0 auto;
      background: #EEF5F6;
      border-radius: 10px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;

      .traintitle {
        color: #000000;
        font-size: 14px;
        box-sizing: border-box;
        padding: 0 30px;
        font-weight: 800;
      }

      img {
        border-radius: 10px;
        width: 173.5px;
        height: 100px;
      }
    }
  }
  .ranks {
    width: 95%;
    margin: 0 auto;

    .top {
      width: 100%;
      border-radius: 10px;
    }

    .ranktitle {
      color: #3D3D3D;
      font-size: 24px;
      margin-top: 10px;
    }

    .carImgP {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 10px 0 10px;

      img {
        width: 100%;
        height: 180px;
      }

      .pContent {
        line-height: 20px;
        margin-top: 10px;

        p {
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
  .popularScience {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;

    .body {
      width: 100%;
      margin: 0 auto;
      p{

      }

      img {
        width: 30%;
        height: 30%;
      }
    }

    .bodycontent {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .bodyTitle {
        font-size: 24px;
        font-weight: normal;
        line-height: 50px;
        letter-spacing: 0px;
        color: #000000;
        box-sizing: border-box;
        padding-top: 50px;
      }

      p {
        font-size: 16px;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0em;
        color: #666666;
        margin: 20px 0;
      }

      .el-button {
        color: #fff;
        margin-top: 10px;
        background: linear-gradient(270deg, #3EDACB 0%, #34B4A8 100%);
        width: 100px;
        height: 40px;
      }
    }

    .bodyFour {
      width: 96%;
      margin: 0 auto;
      box-sizing: border-box;

      .bottomImgs {
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .imgBox {
          width: 30%;
          height: 150px;
        }
      }
    }

    // }
  }
  .twoContent {
    font-size: 12px;
    text-align: center;
    line-height: 20px;
  }
  .popularSciences {
    width: 96%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 10px;
    // img {
    //   margin: 0 auto;
    // }
  }

}

</style>
